export const trimRecursively = <T = unknown>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj), (_key, value) => {
    if (typeof value === 'string') {
      return value.trim();
    }
    return value;
  });
};
